import React, { useState, useContext, useEffect, Fragment } from "react";
import { Row, Col, FormGroup, Label, Form } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import validator from "validator";
import "react-toastify/dist/ReactToastify.css";
//import { faCamera } from "@fortawesome/free-solid-svg-icons";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserContext } from "../../../context/UserContext";
import { Redirect } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/myprofile.css";
import TextField from "@material-ui/core/TextField";
//import validator from 'validator'

import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import blue from "@material-ui/core/colors/blue";
import Fab from "@material-ui/core/Fab";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },

  button: {
    color: blue[1000],
    margin: 1,
    marginTop: 45,
    marginLeft: -35,
    boxShadow: "none",
    background:"transparent",

  },
}));

const Profile = () => {
  const context = useContext(UserContext);
  const classes = useStyles();
  const [prevfirstname, setPrevfirstname] = useState("");
  const [prevlastname, setPrevlastname] = useState("");
  const [prevemail, setPrevemail] = useState("");
  const [prevpath, setPrevpath] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [street, setStreet] = useState("");
  const [zip, setZip] = useState("");
  const [landmark, setLandmark] = useState("");
  const [cityname, setCityname] = useState("");
  const [statename, setStatename] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [socialdatalist, setSocialdatalist] = useState([]);

 
  useEffect(() => {
    // Update the document title using the browser API
    getprofile();
  }, []);
  const getprofile = async () => {
    axios
      .post("LearnerProfile/viewprofile")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setPrevfirstname(res.data.firstName);
          setPrevlastname(res.data.lastName);
          setPrevemail(res.data.email);
          setPrevpath(res.data.prevpath);
          setMobileno(res.data.prevmobileno);
          setAddress(res.data.prevaddress);
          setZip(res.data.prevpin);
          setStreet(res.data.prevstreet);
          setLandmark(res.data.prevlandmark);
          setStatename(res.data.prevstate);
          setCityname(res.data.prevcity);
        
          setSocialdatalist(res.data.socialdatalist);

         

          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const handleInputChange = (event, indexn, siteName) => {
    // console.log("siteName  =" + siteName);
    // console.log("target.value=" + event.target.value);
   
    let newArr = [...socialdatalist]; // copying the old datas array
   
    newArr[indexn].siteprofilelink = event.target.value;
    newArr[indexn].sitename = siteName;
 
    
    setSocialdatalist(newArr);
  };

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const handlerSubmit = (e) => {
    // console.log("sub");
    e.preventDefault();
    saveprofiledetails();
  };

  const saveprofiledetails = async () => {
    setLoading(true);
    var checkurl = false;
     if (socialdatalist) {
      socialdatalist.map((itemn, indexitemn) => {
     
        if (itemn.siteprofilelink && !validator.isURL(itemn.siteprofilelink)) {
          
          checkurl = true;
          return;
        }
        else{
          checkurl = false;
        }
      });
    } 
    if (checkurl) {
     toast.error(" Please enter valid URL ");

          sleep(3000);
          setLoading(false);
      return;
    }

    if (!Number(mobileno)) {
      toast.error("Please enter valid Phone no  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (mobileno && (mobileno.length < 6 || mobileno.length > 12)) {
      toast.error("Please enter valid Phone no , without prefix ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (!validator.isEmail(email) && email) {
      toast.error("Please enter valid email");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (firstname && !firstname.match(/^[a-zA-Z]+$/)) {
      toast.error(" Please enter valid first Name ");
      return;
    } else if (lastname && !lastname.match(/^[a-zA-Z]+$/)) {
      toast.error(" Please enter valid last Name ");
      await sleep(3000);
      setLoading(false);
      return;
    } 
    
    else {
      var formData = new FormData();
      formData.append("fname", firstname);
      formData.append("lname", lastname);
      formData.append("contactemail", email);
      formData.append("mobileno", mobileno);
      formData.append("address", address);
      formData.append("street", street);
      formData.append("zipcode", zip);
      formData.append("state", statename);
      formData.append("city", cityname);
      formData.append("avatar", selectedFile);
      formData.append("landmark", landmark);

      {
        socialdatalist.map((item, i) => (
         
          <>
            {item.siteprofilelink !== ""
              ? formData.append("siteprofilelink", item.siteprofilelink)
              : formData.append("siteprofilelink", "")}
          </>
          //
        ));
      }
      {
        socialdatalist.map((item, i) =>
         
          formData.append("sitename", item.sitename)
        );
      }
      await axios
        .post("LearnerProfile/saveProfile", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            // console.log("Saved Successfully");
            window.location.reload(true);
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  if (!context.user?.email) {
    return <Redirect to="/" />;
  }
  return (
    <div>
      <section class="padding-default2">
        <div class="panel panel-primary card">
          <div class="panel-heading">profile </div>

          <div class="padding-pannele">
            <Form>
              <Row>
                <Col xs="12" sm="12" md="6">
                  <FormGroup row>
                    {prevpath === null ? (
                      <>
                        <div>
                          <img
                            sm={9}
                            class="img-circle width-90 height-90"
                            style={{
                              borderRadius: "90%",
                              width: "100px",
                              height: "100px",
                              border: "1px solid #CCC",
                              marginLeft: "2rem",
                            }}
                            id="blah"
                            src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg"
                            alt=""
                          />
                        </div>

                        <div>
                          <Grid container justify="center" alignItems="center">
                            <input
                              accept="image/*"
                              className={classes.input}
                              id="contained-button-file"
                              name="selectedFile"
                              multiple
                              type="file"
                              onChange={(e) =>
                                setSelectedFile(e.target.files[0])
                              }
                            />

                            <label htmlFor="contained-button-file">
                              <Fab component="span" className={classes.button}>
                                <AddPhotoAlternateIcon />
                              </Fab>
                            </label>
                          </Grid>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <img
                            sm={9}
                            style={{
                              borderRadius: "90%",
                              width: "100px",
                              height: "100px",
                              border: "1px solid #CCC",
                              marginLeft: "2rem",
                            }}
                            id="blah"
                            src={prevpath}
                            alt=""
                          />
                        </div>
                        <div>
                          <Grid container justify="center" alignItems="center">
                            <input
                              accept="image/*"
                              className={classes.input}
                              id="contained-button-file"
                              name="selectedFile"
                              multiple
                              type="file"
                              onChange={(e) =>
                                setSelectedFile(e.target.files[0])
                              }
                            />

                            <label htmlFor="contained-button-file">
                              <Fab component="span" className={classes.button}>
                                <AddPhotoAlternateIcon />
                              </Fab>
                            </label>
                          </Grid>
                        </div>
                      </>
                    )}
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      {prevfirstname === null ? (
                        <TextField
                          id="firstname"
                          name="firstname"
                          style={{ width: "90%" }}
                          onChange={(e) => setFirstname(e.target.value)}
                          label="Enter First Name"
                        />
                      ) : (
                        <TextField
                          id="firstname"
                          name="firstname"
                          style={{ width: "90%" }}
                          value={prevfirstname}
                          readOnly
                          label="Enter First Name"
                        />
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      {prevlastname === null ? (
                        <TextField
                          name="lastname"
                          id="lastname"
                          style={{ width: "90%" }}
                          onChange={(e) => setLastname(e.target.value)}
                          label="Enter Last name"
                        />
                      ) : (
                        <TextField
                          name="lastname"
                          id="lastname"
                          value={prevlastname}
                          style={{ width: "90%" }}
                          readOnly
                        />
                      )}
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Col sm={12}>
                      {prevemail === null ? (
                        <TextField
                          style={{ width: "90%" }}
                          name="email"
                          id="email"
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter Email Address"
                        />
                      ) : (
                        <TextField
                          style={{ width: "90%" }}
                          name="email"
                          id="email"
                          value={prevemail}
                          readOnly
                        />
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      <TextField
                        style={{ width: "90%" }}
                        name="mobileno"
                        id="mobileno"
                        onChange={(e) => setMobileno(e.target.value)}
                        value={mobileno}
                        label="Enter Mobile No"
                      />
                    </Col>
                  </FormGroup>

                  <Label>Link your Accounts </Label><br />
                  {socialdatalist.map((itemname , index) => (
                            <>
                            
                             <div
                             className="getIndex"
                            //  name={socialSiteURLMasterlist[i].socialSiteName}
                           >


                             <TextField
                               id={ itemname.socialid}
                               name="siteprofilelink"
                               style={{ width: "90%" }}
                                pattern="https?://.+"
                                 defaultValue={itemname.siteprofilelink}
                               title="check correct URL format ex. https://www.xyz.in"
                               label={itemname.enterName}
                               onChange={(event) => {
                                 handleInputChange(
                                   event,
                                   itemname.socialid,
                                   itemname.socialSiteName
                                 );
                               }}
                             />
                           </div>
                           </>
                          ))}
                
                </Col>
                <Col xs="12" sm="12" md="6">
                  <FormGroup row>
                    <Col sm={12}>
                      <TextField
                        style={{ width: "90%" }}
                        name="address"
                        id="address"
                        onChange={(e) => setAddress(e.target.value)}
                        value={address}
                        label="Enter Address"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      <TextField
                        style={{ width: "90%" }}
                        name="street"
                        id="street"
                        onChange={(e) => setStreet(e.target.value)}
                        value={street}
                        label="Enter Street"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <br />

                    <Col sm={12}>
                      <TextField
                        style={{ width: "90%" }}
                        name="zip"
                        id="zip"
                        onChange={(e) => setZip(e.target.value)}
                        value={zip}
                        label="Enter Zip Code"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      {landmark === null ? (
                        <TextField
                          style={{ width: "90%" }}
                          name="landmark"
                          id="landmark"
                          onChange={(e) => setLandmark(e.target.value)}
                          label="Enter Landmark"
                        />
                      ) : (
                        <TextField
                          style={{ width: "90%" }}
                          name="landmark"
                          id="landmark"
                          onChange={(e) => setLandmark(e.target.value)}
                          value={landmark}
                          label="Enter Landmark"
                        />
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      <TextField
                        style={{ width: "90%" }}
                        name="cityname"
                        id="cityname"
                        label="Enter City"
                        value={cityname}
                        onChange={(e) => setCityname(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      <TextField
                        style={{ width: "90%" }}
                        name="statename"
                        id="statename"
                        label="Enter State"
                        value={statename}
                        onChange={(e) => setStatename(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
              <br />
              <FormGroup check row>
                <div className="col-lg-12 text-center">
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={loading}
                      onClick={(e) => handlerSubmit(e)}
                    >
                      Submit
                    </Button>

                    {loading === true ? (
                      <CircularProgress
                        size={24}
                        color="green"
                        className="buttonProgress1"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </FormGroup>
              <br />
            </Form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Profile;
